"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {
      position: "relative"
    },
    textBox: {
      display: "grid",
      gridGap: theme.spacing(2),
      gridTemplateColumns: "auto",
      gridTemplateRows: "auto",
      marginBottom: theme.spacing(3)
    },
    buttonBottom: {
      display: "flex",
      justifyContent: "center",
      marginTop: theme.spacing(3)
    },
    swiperRoot: {
      position: "relative"
    },
    swiper: {
      "& .swiper-slide": {
        height: "auto"
      }
    },
    swiperNav: {
      cursor: "pointer",
      left: theme.spacing(2),
      position: "absolute",
      top: "50%",
      transform: "translate(0, calc(-50% - 20px))",
      userSelect: "none",
      zIndex: 1,
      "&.swiper-button-next": {
        left: "auto",
        right: theme.spacing(2)
      },
      "&.swiper-button-disabled": {
        opacity: 0.3
      }
    },
    swiperPagination: {
      display: "flex",
      justifyContent: "center",
      marginTop: theme.spacing(3),
      position: "relative",
      "& .swiper-pagination-bullet": {
        background: theme.palette.grey[400],
        borderRadius: theme.shape.borderRadius,
        cursor: "pointer",
        display: "inline-block",
        height: 8,
        margin: theme.spacing(0, 0.5),
        width: 8
      },
      "& .swiper-pagination-bullet-active": {
        background: theme.palette.primary.main
      }
    }
  };
});
var _default = styles;
exports.default = _default;